import React from 'react';

import { withRouter } from 'react-router-dom';

import LoanService from '../../../Service/LoanService';
import * as moment from 'moment';
import Table from '../../Common/Table';
import { convertToPhilippinesTime } from '../../../AppUtil/AppUtil';
import { hot } from 'react-hot-loader';

class TransfersDueLoan extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			_showModal: false,
			_transferdueloanid: null
		};
	}

	setTranferDueLoanSource = async queryUrl => {
		return LoanService.getAllLoansByUserId(this.props.match.params.id, queryUrl);
	};

	handleShowModal = id => {
		this.setState({
			_showModal: !this.state._showModal,
			_transferdueloanid: id
		});
	};

	render() {
		const dayjs = require('dayjs');

		const tdl = [
			{
				name: 'creation_date',
				label: 'Date/Time',
				options: {
					sort: false,
					customBodyRender: value => {
						return (
							<span className="bold-important">{value ? convertToPhilippinesTime(value) : 'N/A'}</span>
						);
					}
				}
			},

			{
				name: 'id',
				label: 'Loan ID',
				options: {
					sort: true,
					customBodyRender: (value, tableMeta) => {
						let creator_name;
						let acceptor_name;
						if (tableMeta.rowData[6] === 'LEND') {
							creator_name = tableMeta.rowData[7];
						} else if (tableMeta.rowData[6] === 'BORROW') {
							creator_name = tableMeta.rowData[8] || tableMeta.rowData[5];
						}
						if (tableMeta.rowData[6] === 'LEND') {
							acceptor_name = tableMeta.rowData[5] || tableMeta.rowData[8];
						} else if (tableMeta.rowData[6] === 'BORROW') {
							acceptor_name = tableMeta.rowData[7];
						}
						return (
							<a
								href={`/admin/customer/loan/loan-details/${value}?creator_name=${creator_name}&acceptor_name=${acceptor_name}&mode_payment=${
									tableMeta.rowData[3] || tableMeta.rowData[13]
								}`}
								target="_blank">
								<span className="bold-important">{`LA${String(value).padStart(5, '0')}`}</span>
							</a>
						);
					}
				}
			},

			{
				name: 'filtertab',
				label: 'Loan Type',
				options: {
					sort: false,
					customBodyRender: value => {
						value = 'Loan';
						return value;
					}
				}
			},
			{
				name: 'disbursal_mode',
				label: 'disbursal mode',

				options: {
					display: 'excluded'
				}
			},

			{
				name: 'principal_service_fee',
				label: 'principal service fee',

				options: {
					display: 'excluded',
					customBodyRender: value => {
						return <span className="bold-important">{value}</span>;
					}
				}
			},

			{
				name: 'accepted_name',
				label: 'accepted name',

				options: {
					display: 'excluded'
				}
			},
			{
				name: 'loan_type',
				label: 'loan type',

				options: {
					display: 'excluded'
				}
			},

			{
				name: 'creator_name',
				label: 'From',
				options: {
					sort: false,
					customBodyRender: (_value, tableMeta) => {
						if (tableMeta.rowData[6] === 'LEND') {
							return tableMeta.rowData[7];
						} else if (tableMeta.rowData[6] === 'BORROW') {
							return tableMeta.rowData[8] || tableMeta.rowData[5];
						}
					}
				}
			},

			{
				name: 'acceptor_name',
				label: 'To',
				options: {
					sort: false,
					customBodyRender: (_value, tableMeta) => {
						if (tableMeta.rowData[6] === 'LEND') {
							return tableMeta.rowData[5] || tableMeta.rowData[8];
						} else if (tableMeta.rowData[6] === 'BORROW') {
							return tableMeta.rowData[7];
						}
					}
				}
			},

			{
				name: 'channel',
				label: 'Channel',
				options: {
					sort: false,
					customBodyRender: (_value, tableMeta) => {
						if (tableMeta.rowData[3] === 'ACH' || tableMeta.rowData[13] === 'ACH') {
							return 'LendAmi Wallet';
						} else if (tableMeta.rowData[3] === 'OFFLINE' || tableMeta.rowData[13] === 'OFFLINE') {
							return 'Cash/Check';
						} else {
							return 'N/A';
						}
					}
				}
			},

			{
				name: 'principal',
				label: 'Amount(₱) + (LendAmi fee)',
				options: {
					sort: false,
					customBodyRender: (value, tableMeta) => {
						const PHP = new Intl.NumberFormat('PH', {
							style: 'currency',
							currency: 'PHP'
						});
						if (tableMeta.rowData[3] === 'ACH' || tableMeta.rowData[13] === 'ACH') {
							return (
								<span className="bold-important">
									{PHP.format(Number(value) + Number(tableMeta.rowData[4]))}
								</span>
							);
						} else if (tableMeta.rowData[3] === 'OFFLINE' || tableMeta.rowData[13] === 'OFFLINE') {
							return <span className="bold-important">{PHP.format(Number(value))}</span>;
						} else {
							return <span className="bold-important">{PHP.format(Number(value))}</span>;
						}
					}
				}
			},

			{
				name: 'id',
				label: 'Amortization Table',
				options: {
					sort: false,
					customBodyRender: value => (
						<a
							href={`/amortization-table/${value}?id=${this.props.match.params.id}&transferdue=true`}
							style={{ color: 'red', fontWeight: 'bold' }}>
							Transaction
						</a>
					)
				}
			},

			{
				name: 'id',
				label: 'Action',
				options: {
					sort: false,
					customBodyRender: (value, tableMeta) => {
						let creator_name;
						let acceptor_name;
						if (tableMeta.rowData[6] === 'LEND') {
							creator_name = tableMeta.rowData[7];
						} else if (tableMeta.rowData[6] === 'BORROW') {
							creator_name = tableMeta.rowData[8] || tableMeta.rowData[5];
						}
						if (tableMeta.rowData[6] === 'LEND') {
							acceptor_name = tableMeta.rowData[5] || tableMeta.rowData[8];
						} else if (tableMeta.rowData[6] === 'BORROW') {
							acceptor_name = tableMeta.rowData[7];
						}
						return (
							<a
								href={`/admin/customer/loan/loan-details/${value}?creator_name=${creator_name}&acceptor_name=${acceptor_name}&mode_payment=${
									tableMeta.rowData[3] || tableMeta.rowData[13]
								}`}
								target="_blank">
								Detail
							</a>
						);
					}
				}
			},
			{
				name: 'latest_disbursal_mode',
				label: 'latest disbursal mode',

				options: {
					display: 'excluded'
				}
			}
		];

		return (
			<>
				<Table
					columns={tdl}
					dataSourceHandler={this.setTranferDueLoanSource}
					dataSourceName="loan"
					title="Loan Fund Transfer"
				/>
			</>
		);
	}
}

export default withRouter(hot(module)(TransfersDueLoan));
